






import { Component, Vue, Prop } from "vue-property-decorator";
import { BSpinner } from "bootstrap-vue";

@Component({
  components: {
    BSpinner
  }
})
export default class ProviderNotif extends Vue {
  @Prop(String) readonly publicId!: string;
  async mounted() {
    this.$store.commit("main/SET_LOADING", true);
    const { publicId } = this;
    const message = "SMS READ";
    try {
      await this.$store.dispatch("notifs/ackProviderSMS", {
        publicId,
        message
      });
      this.$router.push("/login");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
}
